import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { IsDefined } from "../../../utils/CommonHelper";
import * as actions from "../redux/MasterLayoutAction";
import { Overlay } from "./Overlay";
import { PromotionItem } from "./PromotionItem";

export const PromotionButton = ({
  activepromotionid,
  promotionLists,
  companycode,
  backTo,
  setSwalProps,
  clearPromotion,
}) => {
  const intl = useIntl();
  const [isShow, setIsShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const outerDivProps = () => {
    console.log(window.innerWidth);
    return {
      className:
        "d-flex align-items-center rounded-pill position-fixed px-3 py-1 gap-2 cursor-pointer",
      style: {
        bottom: window.innerWidth > 1300 ? "70px" : "60px",
        left:
          window.innerWidth > 1300
            ? `${(window.innerWidth - 1300) / 2}px`
            : "10px",
        backgroundColor: "rgb(28, 30, 35)",
        boxShadow: "0 4px 8px rgba(192, 130, 130)",
      },
    };
  };

  if (!IsDefined(activepromotionid)) return null;

  const handlePromoClick = (promotionid) =>
    navigate(`/setting/transfer`, {
      state: {
        backTo,
        promotionid: promotionid,
        companycode,
        redirectTo: backTo,
      },
    });

  const handleRemovePromo = () => {
    setIsLoading(true);
    dispatch(
      actions.requestRemovePromoStep1({
        action: "promosettlement_step1",
        promotionid: activepromotionid,
        companycode,
      })
    ).then((resp) => {
      resp = resp.data;
      setIsLoading(false);

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        if (resp.step2 === "true") {
          setSwalProps({
            show: true,
            icon: "question",
            title: intl.formatMessage({
              id: "confirmation",
            }),
            text: intl.formatMessage({ id: resp.message }),
            showCancelButton: true,
            onConfirm: () => {
              setIsLoading(true);
              dispatch(
                actions.requestRemovePromoStep2({
                  action: "promosettlement_step2",
                  promotionid: activepromotionid,
                  companycode,
                })
              ).then((resp) => {
                resp = resp.data;
                setIsLoading(false);

                if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
                  clearPromotion();
                  setSwalProps({
                    show: true,
                    icon: "success",
                    title: intl.formatMessage({ id: "success" }),
                    text: intl.formatMessage({
                      id: "requestRemovePromoSended",
                    }),
                  });
                } else {
                  handleError(resp.message);
                }
              });
            },
          });
        } else {
          handleError(resp.message);
        }
      } else {
        handleError(resp.message);
      }
    });
  };

  const handleError = (errMsg) => {
    setSwalProps({
      show: true,
      icon: "error",
      title: intl.formatMessage({ id: "error" }),
      text: errMsg,
    });
  };

  return (
    <>
      {isLoading && <Overlay />}
      <Modal
        onHide={() => setIsShow(false)}
        show={isShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        data-bs-theme="dark"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-white"
          >
            {intl.formatMessage({ id: "promotion" })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-white d-flex flex-column gap-2">
          {promotionLists?.map((promo) => (
            <PromotionItem
              key={promo.promotionid}
              promo={promo}
              onClick={() => handlePromoClick(promo.promotionid)}
            />
          ))}
        </Modal.Body>
      </Modal>
      {activepromotionid === "" ? (
        promotionLists?.length > 0 && (
          <div {...outerDivProps()} onClick={() => setIsShow(true)}>
            <img
              src={`${process.env.PUBLIC_URL}/image/icon/promotion.png`}
              style={{
                width: "23px",
                height: "23px",
              }}
            />
            <div className="text-white" style={{ fontSize: "13px" }}>
              {intl.formatMessage({ id: "promotion" })}
            </div>
          </div>
        )
      ) : (
        <div {...outerDivProps()}>
          <div
            className="text-white"
            style={{ fontSize: "13px" }}
            onClick={handleRemovePromo}
          >
            {intl.formatMessage({ id: "removePromotion" })}
          </div>
        </div>
      )}
    </>
  );
};
